import { EnvironmentMap } from './getEnvironmentAction';

const last_web_id = window.sessionStorage.getItem('__web_id');
const initialState = {
    environmentLists: {
        adminBaseURL: "",
        commonBaseURL: "",
        userBaseURL: "",
        image_max_size_bytes: "",
        image_max_size_mb: "",
        flag_max_size_kb: "",
        flag_max_size_bytes: ""
    },
    envLoading: true,
    websiteLists :[],
    web_id: last_web_id ? last_web_id : "all"
}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case EnvironmentMap.GET_ENVIRONMENTS_START: {
            return {
                ...state,
            }
        }
        case EnvironmentMap.GET_ENVIRONMENTS_SUCCESS: {
            return {
                ...state,
                environmentLists: action.payload,
                envLoading: false
            }
        }
        case EnvironmentMap.GET_ENVIRONMENTS_ERROR: {
            return {
                ...state,
            }
        } 
        case EnvironmentMap.GET_ENVIRONMENTS_WEBSITE_LIST_SUCCESS: {
            return {
                ...state,
                websiteLists: action.payload,
            }
        }
        case EnvironmentMap.GET_ENVIRONMENTS_WEB_ID: {
            window.sessionStorage.setItem('__web_id',action.payload);
            return {
                ...state,
                web_id: action.payload,
            }
        }
        default: return { ...state }
    }
}